"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFacebookMessenger = function SvgFacebookMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.738 3.879a12.154 12.154 0 0 0-.738 0C9.341 3.637 3.749 8.839 3.508 15.497c-.007.17-.01.338-.008.507a11.862 11.862 0 0 0 3.925 8.968c.205.183.326.44.338.713l.068 2.224a1.001 1.001 0 0 0 1.403.885l2.48-1.094a.998.998 0 0 1 .667-.05 13.69 13.69 0 0 0 3.619.48c6.696.204 12.291-5.06 12.495-11.756.204-6.698-5.06-12.292-11.756-12.495h-.002Zm6.767 9.33-3.67 5.823a1.876 1.876 0 0 1-2.711.5l-2.92-2.19a.75.75 0 0 0-.903.003L9.355 20.34a.593.593 0 0 1-.86-.79l3.673-5.825a1.878 1.878 0 0 1 2.71-.5l2.92 2.19a.749.749 0 0 0 .903-.001l3.944-2.994a.595.595 0 0 1 .86.79Z",
    fill: "url(#facebook_messenger_svg__a)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "facebook_messenger_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-54.839 32.025 6.218) scale(26.663 26.6571)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0496FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#4B6AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#6E53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#A534F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#E048AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6967"
  }))));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgFacebookMessenger);
var _default = Memo;
exports["default"] = _default;